import type { PricingVersionTuple } from '../../model/model.ts'

import type { FrRccwPricingVersionFormat } from './model.ts'

export const frRccwPricingVersions = [
  ['pricing-fr-rcc-wakam-1.0.0-2026-08-02', { label: 'Initial version' }],
] as const satisfies PricingVersionTuple<FrRccwPricingVersionFormat>[]

export type FrRccwPricingVersion = (typeof frRccwPricingVersions)[number][0]
